import { isTouchDevice } from '../user/device-info';

export default function initTooltips(): void {
    document.querySelectorAll<HTMLElement>( '.tooltip' ).forEach( ( tooltip: HTMLElement ): void => {
        if ( !tooltip.dataset.tooltip || tooltip.dataset.tooltip.length === 0 ) {
            return;
        }

        if ( tooltip.classList.contains( 'tooltip--initialised' ) ) {
            return;
        }

        const content = document.createElement( 'div' );
        content.className = 'tooltip__text';
        content.innerHTML = tooltip.dataset.tooltip || '';

        const close = function() {
            tooltip.classList.remove( 'tooltip--active' );
            content.style.position = '';
            content.style.top = '';
            content.style.left = '';
            content.style.transform = '';
        };

        if ( isTouchDevice() ) {
            const closeBtn = document.createElement( 'button' );
            closeBtn.className = 'tooltip__close';
            closeBtn.type = 'button';

            closeBtn.addEventListener( 'click', ( event: Event ): void => {
                event.stopPropagation();
                close();
            } );

            content.appendChild( closeBtn );
        }

        tooltip.insertAdjacentElement( 'beforeend', content );

        [ 'mouseenter', 'click' ].forEach( ( eventName: string ) => {
            tooltip.addEventListener( eventName, ( event: Event ): void => {
                if ( event.type === 'click' && tooltip.classList.contains( 'tooltip--active' ) ) {
                    close();
                    return;
                } else if ( tooltip.classList.contains( 'tooltip--active' ) ) {
                    return;
                }

                document.querySelectorAll<HTMLElement>( '.tooltip--active' ).forEach( ( el: HTMLElement ) => el.classList.remove( 'tooltip--active' ) );

                tooltip.classList.add( 'tooltip--active' );

                const contentRect: DOMRect = content.getBoundingClientRect();

                let translateX = 0;

                if ( contentRect.right >= window.innerWidth ) {
                    let buffer = 10;

                    if ( window.innerWidth >= 768 ) {
                        buffer = 20;
                    }

                    if ( window.innerWidth >= 992 ) {
                        buffer = 40;
                    }

                    translateX = ( window.innerWidth - contentRect.right ) - buffer;
                }

                const btnRect: DOMRect = tooltip.getBoundingClientRect();

                const top = Math.ceil( btnRect.top + ( tooltip.offsetHeight + 10 ) );
                const left = btnRect.left;

                content.style.position = 'fixed';
                content.style.top = `${top}px`;
                content.style.left = `${left}px`;
                content.style.transform = `translate3d(${translateX}px, 0, 0)`;
            } );
        } );

        [ 'mouseleave' ].forEach( ( eventName: string ) => {
            tooltip.addEventListener( eventName, ( event: Event ) => {
                close();
            } );
        } );

        tooltip.classList.add( 'tooltip--initialised' );
    } );
}
